import script from "./PendingOrdersListSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingOrdersListSection.vue?vue&type=script&setup=true&lang=ts"

import "./PendingOrdersListSection.vue?vue&type=style&index=0&id=f667ef56&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f667ef56"]])

export default __exports__